import React from "react";
import { useStyles } from "../Common/CommonStyle";
import ScanningFooter from "../Common/ScanningFooter";
import Success from "../Common/Success";
import VideoPlayer from "../Common/VideoPlayer";
import ChatComponent from "./ChatComponent";
import chatList from "./chatList.json";
import CustomChatComponent from "./CustomChatComponent";
import CustomDeleteProcess from "./CustomDeleteProcess";
import DisconnectNetwork from "./DisconnectNetwork";
import DisconnectProcess from "./DisconnectProcess";
import DisplayOfOptionComponent from "./DisplayOfOptionComponent";

export interface IHelpInteraction {
  startSlide?: string;
  scenario3Stage1Finish: () => void;
  scenario3Stage2Finish: () => void;
}

const HelpInteraction = ({
  startSlide,
  scenario3Stage1Finish,
  scenario3Stage2Finish,
}: IHelpInteraction) => {
  const classes = useStyles();
  const [nextSlide, showNextSlide] = React.useState(
    startSlide === "delete_malicious_code" ? 8 : 0,
  );
  const displayNextSlide = () => {
    showNextSlide(nextSlide + 1);
  };

  return (
    <>
      {nextSlide === 0 ? (
        <ChatComponent
          chatList={chatList[0]}
          displayNextSlide={displayNextSlide}
        />
      ) : nextSlide === 1 ? (
        <DisplayOfOptionComponent displayNextSlide={displayNextSlide} />
      ) : nextSlide === 2 ? (
        <div
          //className={classes.positionComponent}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // width: "100%",
          }}
        >
          {/* To add specific play time for video
           #t=[(start_time), (end_time)]
           to the end of your media URL */}
          <VideoPlayer
            videoURL={"asset/video/ScanningProgressVideo.mp4#t=0,5"}
            displayNextSlide={displayNextSlide}
            isAnimation={true}
            styles={{
              position: "absolute",
              left: "27%",
              top: "8rem",
              marginTop: "0rem",
              height: "55%",
              width: "70%",
            }}
          />
        </div>
      ) : nextSlide === 3 ? (
        <ChatComponent
          chatList={chatList[3]}
          displayNextSlide={displayNextSlide}
          consoleImg={true}
        />
      ) : nextSlide === 4 ? (
        <DisconnectNetwork
          displayNextSlide={displayNextSlide}
          consoleImg={true}
        />
      ) : nextSlide === 5 ? (
        <DisconnectProcess displayNextSlide={displayNextSlide} />
      ) : nextSlide === 6 ? (
        <Success
          displayNextSlide={displayNextSlide}
          message1={"Successfully disconnected"}
          message2={"outside networks!"}
          consoleImg={true}
        />
      ) : nextSlide === 7 ? (
        <>
          <ChatComponent
            chatList={chatList[4]}
            displayNextSlide={displayNextSlide}
            overlayLoader={1}
            isRoom={true}
            consoleImg={true}
          />
          {scenario3Stage1Finish()}
        </>
      ) : nextSlide === 8 ? (
        <CustomChatComponent displayNextSlide={displayNextSlide} type={0} />
      ) : nextSlide === 9 ? (
        <CustomDeleteProcess displayNextSlide={displayNextSlide} type={0} />
      ) : nextSlide === 10 ? (
        <CustomChatComponent displayNextSlide={displayNextSlide} type={1} />
      ) : nextSlide === 11 ? (
        <CustomChatComponent displayNextSlide={displayNextSlide} type={2} />
      ) : nextSlide === 12 ? (
        <DisconnectProcess
          displayNextSlide={displayNextSlide}
          type={1}
          fullWidthConsole={true}
        />
      ) : nextSlide === 13 ? (
        <CustomChatComponent displayNextSlide={displayNextSlide} type={3} />
      ) : nextSlide === 14 ? (
        <>{scenario3Stage2Finish()}</>
      ) : null}
      {(nextSlide === 2 || nextSlide === 3) && <ScanningFooter />}
    </>
  );
};

export default HelpInteraction;
